import { OctagonWarningContainedIcon } from '@ankr.com/ui';

import { isBundleChargingModel } from 'modules/billing/utils/isBundleChargingModel';
import { useChargingModel } from 'modules/billing/hooks/useChargingModel';
import { useIsUserSuspended } from 'modules/accountStatus/hooks/useIsUserSuspended';

import { BundleStatusIcon } from '../BundleStatusIcon';
import { useBalanceStatusIconStyles } from './useBalanceStatusIconStyles';

export const BalanceStatusIcon = () => {
  const isSuspended = useIsUserSuspended();

  const chargingModel = useChargingModel();

  const { classes } = useBalanceStatusIconStyles();

  if (isSuspended) {
    return <OctagonWarningContainedIcon className={classes.error} size={20} />;
  }

  if (isBundleChargingModel(chargingModel)) {
    return (
      <BundleStatusIcon
        classes={classes}
        left={chargingModel.usage.leftPercent}
      />
    );
  }

  return null;
};
